import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { CreateApplicationRequest } from 'commons/types/DTO/bank/applications/manage/CreateApplicationRequest'

import { createApplication as createApplicationService } from '../service'

export const useCreateApplication: WriteHook<CreateApplicationRequest, unknown> = (opts) =>
  useMutationManager(createApplicationService, opts)
